"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalErrorHandler = void 0;
const react_design_system_1 = require("@hdh-core/react-design-system");
const mfe_common_common_utils_lib_1 = require("mfe-common-common-utils-lib");
const react_1 = __importDefault(require("react"));
const GlobalErrorHandler = () => {
    const notificationData = (0, mfe_common_common_utils_lib_1.useNotificationHelper)();
    return notificationData.isGlobalError && react_1.default.createElement(react_design_system_1.Notification, Object.assign({}, notificationData));
};
exports.GlobalErrorHandler = GlobalErrorHandler;
